import { getUsersByGroup } from "../../services/userGroups";
import { fetchUsersByGroupFailure, fetchUsersByGroupRequest, fetchUsersByGroupSuccess } from "./userGroupsActionCreator";

export async function fetchUsersByGroup(dispatch: Function, identifier: string, queryParams: any) {
  dispatch(fetchUsersByGroupRequest());
  try {
    // @ts-ignore
    const { data, metadata } = await getUsersByGroup(identifier, queryParams)
    dispatch(fetchUsersByGroupSuccess(data, metadata));
    return { data, metadata };
  } catch (error: any) {
    dispatch(fetchUsersByGroupFailure(error.message));
    return { data: [], metadata: {} };
  }
}